export const genericAdvisory = "Warning: this action cannot be undone";

export const advisoryRestorePreviousSession = `Warning: this action cannot be undone.
If you have not saved your changes after deleting this
item and would like to restore the previous settings, refresh the page.`;
